import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    TextField,
    Box,
    CircularProgress // 👈 ADDED
} from "@mui/material";

export default function ReportOrderDialog({
    open,
    onClose,
    cancelReason,
    setCancelReason,
    showCancelInput,
    setShowCancelInput,
    confirmCancelOpen,
    setConfirmCancelOpen,
    handleCancelOrder,
    actionLoading // 👈 ADDED PROP
}) {

    return (
        <>
            {/* 🚨 REPORT DIALOG */}
            <Dialog
                open={open}
                onClose={() => {
                    onClose();
                    setShowCancelInput(false);
                }}
                fullWidth
                maxWidth="xs"
                slotProps={{
                    paper: {
                        sx: {
                            borderRadius: "24px",
                            p: 1
                        }
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        fontWeight: "800",
                        textAlign: "center",
                        color: "#d32f2f"
                    }}
                >
                    Report Order
                </DialogTitle>

                <DialogContent>

                    {/* STEP 1 */}
                    {!showCancelInput && (

                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 2,
                                mt: 1
                            }}
                        >

                            <Button
                                fullWidth
                                variant="outlined"
                                color="error"
                                onClick={() => setShowCancelInput(true)}
                                sx={{
                                    borderRadius: "14px",
                                    py: 1.5,
                                    fontWeight: "700",
                                    textTransform: "none"
                                }}
                            >
                                ❌ Cancel Order
                            </Button>

                        </Box>
                    )}

                    {/* STEP 2 */}
                    {showCancelInput && (

                        <Box sx={{ mt: 1 }}>

                            <Typography
                                sx={{
                                    mb: 2,
                                    color: "#546e7a",
                                    fontWeight: "500"
                                }}
                            >
                                * Please write cancellation reason
                            </Typography>

                            <TextField
                                fullWidth
                                multiline
                                rows={4}
                                placeholder="Write reason here..."
                                value={cancelReason}
                                onChange={(e) =>
                                    setCancelReason(e.target.value)
                                }
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: "14px"
                                    }
                                }}
                            />

                        </Box>
                    )}

                </DialogContent>

                <DialogActions
                    sx={{
                        px: 3,
                        pb: 2
                    }}
                >

                    <Button
                        onClick={() => {
                            onClose();
                            setShowCancelInput(false);
                        }}
                    >
                        Close
                    </Button>

                    {showCancelInput && (
                        <Button
                            variant="contained"
                            color="error"
                            disabled={!cancelReason.trim()}
                            onClick={() => setConfirmCancelOpen(true)}
                            sx={{
                                borderRadius: "12px",
                                fontWeight: "700",
                                textTransform: "none",

                                "&.Mui-disabled": {
                                    background: "#ffcdd2",
                                    color: "#ffffff"
                                }
                            }}
                        >
                            Submit
                        </Button>
                    )}

                </DialogActions>
            </Dialog>

            {/* 🚨 CONFIRM CANCEL ALERT */}
            <Dialog
                open={confirmCancelOpen}
                // 👈 Prevent closing the dialog by clicking outside if loading is active
                onClose={actionLoading ? undefined : () => setConfirmCancelOpen(false)} 
                maxWidth="xs"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: "24px",
                        p: 1,
                        background:
                            "linear-gradient(135deg, #ffffff 0%, #fff5f5 100%)"
                    }
                }}
            >

                <DialogContent
                    sx={{
                        textAlign: "center",
                        py: 4
                    }}
                >

                    <Box
                        sx={{
                            width: 80,
                            height: 80,
                            mx: "auto",
                            borderRadius: "50%",
                            background:
                                "linear-gradient(135deg, #ef5350 0%, #d32f2f 100%)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "white",
                            fontSize: "2.5rem",
                            mb: 3,
                            boxShadow:
                                "0 10px 30px rgba(211,47,47,0.35)"
                        }}
                    >
                        !
                    </Box>

                    <Typography
                        sx={{
                            fontWeight: "800",
                            fontSize: "1.4rem",
                            color: "#c62828",
                            mb: 1
                        }}
                    >
                        Cancel Order?
                    </Typography>

                    <Typography
                        sx={{
                            color: "#546e7a",
                            lineHeight: 1.7
                        }}
                    >
                        Are you sure you want to cancel this order?
                        <br />
                        This action cannot be undone.
                    </Typography>

                </DialogContent>

                <DialogActions
                    sx={{
                        px: 3,
                        pb: 3,
                        gap: 2,
                        justifyContent: "center"
                    }}
                >

                    <Button
                        variant="outlined"
                        onClick={() => setConfirmCancelOpen(false)}
                        disabled={actionLoading} // 👈 Disable NO button while loading
                        sx={{
                            borderRadius: "12px",
                            px: 4,
                            fontWeight: "700",
                            textTransform: "none"
                        }}
                    >
                        No
                    </Button>

                    <Button
                        variant="contained"
                        color="error"
                        disabled={actionLoading} // 👈 Disable YES button while loading
                        onClick={() => {
                            // 👇 Removed setConfirmCancelOpen(false) so the dialog stays open to show the spinner
                            handleCancelOrder();
                        }}
                        sx={{
                            borderRadius: "12px",
                            px: 4,
                            fontWeight: "700",
                            textTransform: "none",
                            boxShadow:
                                "0 6px 20px rgba(211,47,47,0.35)",
                            minWidth: "140px" // 👈 Keep button width stable when text changes to spinner
                        }}
                    >
                        {/* 👈 TERNARY OPERATOR FOR LOADING SPINNER */}
                        {actionLoading ? (
                            <CircularProgress size={24} sx={{ color: "#fff" }} />
                        ) : (
                            "Yes, Cancel"
                        )}
                    </Button>

                </DialogActions>
            </Dialog>
        </>
    );
}